export default {
  registryText: '{mainText} journey started {time} ago.',
  year: '{n} Year | {n} Year | {n} Years',
  newComer: `${import.meta.env.VITE_BRAND === 'OPPO' ? 'Newcomer' : 'Cupcake'}`,
  milestones: 'Milestones',
  inspirationPath: 'Inspiration Path',
  level: 'Lv.{n}',
  your: 'Your',
  their: 'Their',
  validateAbnormal: 'Your input has disallowed elements. Please edit and retry.'
}